
import { useState } from "react"
import { useToast } from "@/hooks/use-toast"
import { supabase } from "@/integrations/supabase/client"

interface UsePaymentProps {
  initialDeliveryMethod?: string | null
}

export const usePayment = ({ initialDeliveryMethod }: UsePaymentProps = {}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(initialDeliveryMethod || null)
  const [clientSecret, setClientSecret] = useState<string | null>(null)
  const [processing, setProcessing] = useState(false)
  const [showLetterEditor, setShowLetterEditor] = useState(false)
  const [discountCode, setDiscountCode] = useState("")
  const [currentAmount, setCurrentAmount] = useState<number | null>(null)
  const { toast } = useToast()

  const handleOptionSelect = async (optionId: string, deliveryOptions: any[]) => {
    setSelectedOption(optionId)
    setClientSecret(null)
    const option = deliveryOptions.find(opt => opt.id === optionId)
    if (option) {
      setCurrentAmount(option.price)
      localStorage.setItem('selectedDeliveryMethod', option.title)
      localStorage.setItem('paymentAmount', (option.price * 100).toString())
    }
    await applyDiscountCode(optionId, deliveryOptions)
  }

  const applyDiscountCode = async (optionId?: string, deliveryOptions?: any[]) => {
    if (!deliveryOptions) return
    
    const option = deliveryOptions.find(opt => opt.id === (optionId || selectedOption))
    if (!option) return

    try {
      const { data, error } = await supabase.functions.invoke('create-payment-intent', {
        body: { 
          amount: option.price * 100, 
          priceId: option.priceId,
          discountCode 
        }
      })

      if (error) throw error

      if (data.freeTransaction) {
        handlePaymentSuccess()
      } else {
        setClientSecret(data.clientSecret)
        if (discountCode) {
          toast({
            title: "Success",
            description: "Discount code applied successfully!",
          })
        }
      }
    } catch (error: any) {
      console.error('Error:', error)
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to apply discount code.",
      })
    }
  }

  const handlePaymentSuccess = () => {
    setShowLetterEditor(true)
  }

  return {
    selectedOption,
    clientSecret,
    processing,
    showLetterEditor,
    discountCode,
    currentAmount,
    setDiscountCode,
    handleOptionSelect,
    applyDiscountCode,
    handlePaymentSuccess,
    setShowLetterEditor
  }
}
